import { render } from "./GameCards.vue?vue&type=template&id=77f79c27"
import script from "./GameCards.vue?vue&type=script&lang=js"
export * from "./GameCards.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__